import { render } from "./DomaciTVComponen.vue?vue&type=template&id=a5bec7da&scoped=true"
import script from "./DomaciTVComponen.vue?vue&type=script&lang=js"
export * from "./DomaciTVComponen.vue?vue&type=script&lang=js"

import "./DomaciTVComponen.vue?vue&type=style&index=0&id=a5bec7da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5bec7da"]])

export default __exports__